import Blueberry from "./images/Blueberry_Cheesecake Image.png";
import Biscoff from "./images/Biscoff-lmg.png";
import Chocolate from "./images/chocolate_cheesecake img.png";

const Datamenu = [
    {
        id: 1,
        picture: Blueberry,
        cakeTitle: "Blueberry Cheesecake",
        caption: "Blueberry love, cheesecake delight!",
        price: "9.00"
    },
    {
        id: 2,
        picture: Biscoff,
        cakeTitle: "Biscoff Cheesecake",
        caption: "Biscoff adores cheesecake magic",
        price: "11.00"
    },
    {
        id: 3,
        picture: Chocolate,
        cakeTitle: "Chocolate Cheesecake",
        caption: "Cherish chocolate, relish cheesecake magic!",
        price: "10.00"
    }
];
export default Datamenu;